import type {
  ActiveTransit,
  ProductRecommendation,
  SadeSatiInfo,
  TransitIngress,
  TransitPosition,
  TransitResponse,
  UpcomingTransitsResponse,
} from "@ishvaram/api-client";
import { apiRequest } from "./_fetch";

export type {
  ActiveTransit,
  ProductRecommendation,
  SadeSatiInfo,
  TransitIngress,
  TransitPosition,
  TransitResponse,
  UpcomingTransitsResponse,
};

export async function getCurrentTransits(
  moonRashi: string,
  dateStr?: string
): Promise<TransitResponse> {
  const params = new URLSearchParams({ moon_rashi: moonRashi });
  if (dateStr) params.set("date", dateStr);
  return apiRequest<TransitResponse>(`/transits/current?${params}`);
}

export async function getPersonalTransits(data: {
  birth_date: string;
  birth_time: string | null;
  birth_place: string;
  language?: string;
}): Promise<TransitResponse> {
  return apiRequest<TransitResponse>("/transits/personal", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
}

export async function getUpcomingTransits(
  days = 30,
  moonRashi?: string
): Promise<UpcomingTransitsResponse> {
  const params = new URLSearchParams({ days: String(days) });
  if (moonRashi) params.set("moon_rashi", moonRashi);
  return apiRequest<UpcomingTransitsResponse>(`/transits/upcoming?${params}`);
}
